import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useReducer, lazy, useEffect } from "react";
import { AuthContext, AuthDispatchContext, authReducer, EMPTY_AUTH_STATE, } from "./AuthContext";
import { clearAccessToken } from "./access-token";
import { CustomPrivyProvider } from "./providers/privy/CustomPrivyProvider";
const FarcasterWagmiProvider = lazy(() => import("./providers/farcaster/provider"));
export const AuthProvider = ({ children, mode = "privy" }) => {
    if (mode === "farcaster") {
        return _jsx(FarcasterAuthProvider, { children: children });
    }
    return _jsx(PrivyAuthProvider, { children: children });
};
export const FarcasterAuthProvider = ({ children, }) => {
    const [auth, dispatch] = useReducer(authReducer, {
        ...EMPTY_AUTH_STATE,
        mode: "farcaster",
    });
    return (_jsx(AuthContext.Provider, { value: auth, children: _jsx(AuthDispatchContext.Provider, { value: dispatch, children: _jsx(FarcasterWagmiProvider, { children: children }) }) }));
};
export const PrivyAuthProvider = ({ children, }) => {
    useEffect(() => {
        // this clears saved access token from sign in method
        // to make sure if does not interfere with privy sign in
        clearAccessToken();
    }, []);
    const [auth, dispatch] = useReducer(authReducer, EMPTY_AUTH_STATE);
    return (_jsx(AuthContext.Provider, { value: auth, children: _jsx(AuthDispatchContext.Provider, { value: dispatch, children: _jsx(CustomPrivyProvider, { children: children }) }) }));
};
